import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export function createConfigContext() {
    return createContext(null);
}
export function createUseConfig() {
    return () => {
        const config = useContext(ConfigContext);
        if (!config) {
            throw new Error('Configuration used without ConfigProvider!');
        }
        return config; // leap of faith from the truly instantiated config object in the project
    };
}
export const ConfigContext = createConfigContext();
export function ConfigProvider({ config, children, }) {
    return (_jsx(ConfigContext.Provider, { value: config, children: children }));
}
export function useBaseConfig() {
    const config = useContext(ConfigContext);
    if (!config) {
        throw new Error('Configuration used without ConfigProvider!');
    }
    return config;
}
